import React from 'react'
import Select from 'react-select'
import {preventDefaults} from 'survey-creator-react'

const normalizeSearchText = (value) =>
  (value ?? '')
    .toString()
    .trim()
    .toLocaleLowerCase('tr')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

const CustomSelect = (props) => {
  const handleMenuOpen = (event) => {
    event.stopPropagation()
    preventDefaults(event)
  }

  const defaultFilterOption = (option, rawInput) => {
    const normalizedInput = normalizeSearchText(rawInput)

    if (!normalizedInput) {
      return true
    }

    const normalizedLabel = normalizeSearchText(option?.label)
    const normalizedValue = normalizeSearchText(option?.value)
    const normalizedData = normalizeSearchText(option?.data?.label ?? option?.data?.value)

    return (
      normalizedLabel.includes(normalizedInput) ||
      normalizedValue.includes(normalizedInput) ||
      normalizedData.includes(normalizedInput)
    )
  }

  return (
    <Select
      {...props}
      filterOption={props.filterOption ?? defaultFilterOption}
      onMouseDown={(event) => {
        handleMenuOpen(event)
        if (props.onMenuOpen) {
          props.onMenuOpen(event)
        }
      }}
    />
  )
}

export default CustomSelect
